/* 🤖 this file was generated by svg-to-ts */
export const kzIconsSend: {
  name: 'send';
  data: string;
} = {
  name: 'send',
  data: `<svg fill="none" viewBox="0 0 25 24"><path d="m22.5 2-11 11M22.5 2l-7 20-4-9-9-4 20-7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
